module.exports = __webpack_public_path__ + "static/media/Ordkjedetest-Feil-ost-par-vask-jakt.63061a1f.m4a";